(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hai-product-recommendations')) {
    // 负责加载 Shopify 推荐结果，并在当前区块内创建独立的 Swiper 实例。
    class HaiProductRecommendations extends HTMLElement {
      async connectedCallback() {
        const url = this.dataset.url;

        if (this.querySelector('.hai-product-recommendations__item')) {
          this.dataset.loaded = 'true';
          this.initializeSwiper();
          return;
        }

        if (!url || this.dataset.loaded === 'true') return;

        this.dataset.loaded = 'true';

        try {
          // 正式店铺必须通过推荐接口读取 Shopify Search & Discovery 中手工选择的商品。
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error(`Product recommendations request failed: ${response.status}`);
          }

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const recommendationsGrid = documentFragment.querySelector('.hai-product-recommendations__grid');
          const currentGrid = this.querySelector('.hai-product-recommendations__grid');

          if (recommendationsGrid && currentGrid) {
            currentGrid.replaceWith(recommendationsGrid);
            this.initializeSwiper();
          }
        } catch (error) {
          console.error(error);
        }
      }

      initializeSwiper(retryCount = 0) {
        const slider = this.querySelector('[data-product-recommendations-swiper]');

        if (!slider || slider.swiper || !slider.querySelector('.swiper-slide')) return;

        if (!window.Swiper) {
          // Swiper 在主题中使用 defer 加载，等待全局脚本就绪后再初始化。
          if (retryCount < 20 && this.isConnected) {
            this.swiperRetryTimer = window.setTimeout(() => this.initializeSwiper(retryCount + 1), 120);
          }
          return;
        }

        const controls = this.querySelector('[data-product-recommendations-controls]');
        const scrollbar = this.querySelector('[data-product-recommendations-scrollbar]');

        this.swiper = new window.Swiper(slider, {
          slidesPerView: 1.15,
          spaceBetween: 16,
          grabCursor: true,
          watchOverflow: true,
          speed: 500,
          observer: true,
          observeParents: true,
          navigation: {
            prevEl: this.querySelector('[data-product-recommendations-prev]'),
            nextEl: this.querySelector('[data-product-recommendations-next]')
          },
          scrollbar: {
            el: scrollbar,
            draggable: true
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          on: {
            // 商品数量不超过当前断点的可见数量时，不展示无效的切换控件。
            init: (swiper) => this.updateControls(swiper, controls, scrollbar),
            lock: (swiper) => this.updateControls(swiper, controls, scrollbar),
            unlock: (swiper) => this.updateControls(swiper, controls, scrollbar),
            resize: (swiper) => this.updateControls(swiper, controls, scrollbar)
          },
          breakpoints: {
            750: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24
            }
          }
        });
      }

      updateControls(swiper, controls, scrollbar) {
        const hasOverflow = !swiper.isLocked;

        if (controls) controls.hidden = !hasOverflow;
        if (scrollbar) scrollbar.hidden = !hasOverflow;
      }

      disconnectedCallback() {
        window.clearTimeout(this.swiperRetryTimer);

        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }

    customElements.define('hai-product-recommendations', HaiProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videobg-txt"] && !Shopify.designMode) return;
  try {
    
  // The click event is now handled by an inline onclick attribute on the .video-accordian-heading element
  // for simplicity and to avoid issues with section rendering.

  } catch(e) { console.error(e); }
})();
})();
